import { Component, Input, OnInit } from '@angular/core';
import {
  ICardAccess,
  ICardCredentials,
} from 'src/app/user-management/user-management-interfaces';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';

@Component({
  selector: 'app-user-physical-credentials-access',
  templateUrl: './user-physical-credentials-access.component.html',
  styleUrls: ['./user-physical-credentials-access.component.scss'],
})
export class UserPhysicalCredentialsAccessComponent implements OnInit {
  @Input() selectedCredentials: any;
  readonly LANG_CONST = LANG_CONST;
  CONSTANTS = CONSTANTS;
  commonAccessControl!: boolean; 

  constructor( private sharedDataService: SharedDataService, private stateManagementService: StateManagementService) {}

  ngOnInit(): void {
    this.commonAccessControl = this.stateManagementService.getSharedData()?.selectedSite?.commonAccessControl;
    if (!this.commonAccessControl) {
      delete this.selectedCredentials?.cardAccess?.otherAccess;
    }
  }
}
